export default __webpack_public_path__ + "img/fcf64e231a6712370d45becf18db279a.svg";